import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { createContact, deleteContact, getContacts, updateContact } from '../../api/contacts';
import { useEnvironment } from '../useEnvironment/useEnvironment';
import type { IContactInput } from '../../types';

export const useContacts = (tenant: string) => {
  const { environment } = useEnvironment();
  return useQuery({
    queryKey: ['contacts', environment, tenant],
    queryFn: () => getContacts(environment, tenant),
    select: ({ data }) => data,
    enabled: Boolean(tenant),
  });
};

export const useContactMutations = (tenant: string) => {
  const { environment } = useEnvironment();
  const client = useQueryClient();
  const refresh = () => client.invalidateQueries({ queryKey: ['contacts', environment, tenant] });
  const create = useMutation({
    mutationFn: (input: IContactInput) => createContact(environment, tenant, input),
    onSuccess: refresh,
  });
  const update = useMutation({
    mutationFn: ({ id, input }: { id: string; input: IContactInput }) =>
      updateContact(environment, tenant, id, input),
    onSuccess: refresh,
  });
  const remove = useMutation({
    mutationFn: (id: string) => deleteContact(environment, tenant, id),
    onSuccess: refresh,
  });
  return { create, update, remove };
};
